import { DataLayerPayload } from './datalayer_payload';

type DataLayerPrimitive = string | number | boolean;
type DataLayerValue = DataLayerPrimitive | DataLayerPrimitive[];

interface GTMEvent {
  event: string;
  eventPayload: Record<string, DataLayerValue>;
}

function ensureDataLayer(): GTMEvent[] {
    const raw = (window as unknown).dataLayer;

    // If it's an array, we're fine
    if (Array.isArray(raw)) {
        return raw as GTMEvent[];
    }

    // If it's a single object, wrap it
    if (typeof raw === 'object') {
        const fixed: GTMEvent[] = [raw];
        (window as unknown).dataLayer = fixed;
        return fixed;
    }

    // Otherwise, fall back to an empty array
    const fallback: GTMEvent[] = [];
    (window as unknown).dataLayer = fallback;
    return fallback;
}

export function updateDataLayer(event: string, dataset: DOMStringMap): void {
    const payload = new DataLayerPayload(
        dataset.eventBoxofficeid,
        dataset.productionTitle,
        dataset.productionSubtitle,
        dataset.eventStart,
        dataset.productionType
    );

    ensureDataLayer().push({
        event,
        eventPayload: payload.build()
    });
}

